import { render, staticRenderFns } from "./reward-shield.vue?vue&type=template&id=a71e3b3e"
import script from "./reward-shield.vue?vue&type=script&lang=js"
export * from "./reward-shield.vue?vue&type=script&lang=js"
import style0 from "./reward-shield.vue?vue&type=style&index=0&id=a71e3b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports